<template>
    <div v-if="bundle" class="bundle-preview">
        <section>
            <span class="title">{{ $t('campaignsPage.bundles.bundleName') }}</span>
            <span selenium-id="bundleName" class="bundle-name">{{ bundle.name }}</span>
        </section>

        <section>
            <span class="title">{{ $t('global.description') }}</span>

            <span selenium-id="bundleDescription">{{ bundle.description }}</span>
        </section>

        <section>
            <span class="title">{{ $t('campaignsPage.bundles.metrics') }}</span>

            <span class="metrics">
                <div class="metric">
                    <span v-if="bundle.solutionRefs" selenium-id="campaignCount" class="metric-value">
                        {{ bundle.solutionRefs.length }}
                    </span>
                    <span v-if="bundle.solutions" selenium-id="campaignCount" class="metric-value">
                        {{ bundle.solutions.length }}
                    </span>

                    {{ $t('campaignsPage.campaigns') }}
                </div>
            </span>
        </section>

        <section>
            <span class="title">{{ $t('campaignsPage.campaigns') }}</span>

            <div v-if="loading" class="placeholder-container">
                <DsPlaceholder
                    v-for="n in bundle.solutions.length"
                    :key="n"
                    class="placeholder"
                    :rows="rows"
                />
            </div>

            <div v-else class="campaigns">
                <div v-if="bundle.solutionRefs">
                    <p v-for="{ id, name } in bundle.solutionRefs" :key="id">
                        {{ name }}
                    </p>
                </div>

                <div v-else>
                    <div class="campaign header">
                        <span>{{ $t('campaignsPage.bundles.name') }}</span>
                        <span class="date">{{ $t('campaignsPage.bundles.published') }}</span>
                    </div>

                    <template v-if="bundle.solutions">
                        <div
                            v-for="{ id, name, dateCreated } in bundle.solutions"
                            :key="id"
                            class="campaign"
                        >
                            <span selenium-id="campaignName">{{ name }}</span>
                            <span selenium-id="campaignPublishedDate" class="date">{{ formatDate(dateCreated) }}</span>
                        </div>
                    </template>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import dateUtils from '@/mixins/date-utils';

export default {
    mixins: [dateUtils],

    props: {
        bundle: Object,
        loading: Boolean,
    },

    data() {
        return {
            rows: [{ height: '1rem', boxes: [3, 1] }],
        };
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .bundle-preview {
        flex-direction: column;

        section {
            display: flex;
            padding: $spacing-300;
            color: $color-gray-800;

            .title {
                text-align: right;
                margin-right: $spacing-200;
                color: $color-gray-700;
                width: 100px;
            }

            span:not(.title) {
                flex: 1;
            }

            &:not(:first-child) {
                border-top: 1px solid $color-gray-300;
            }

            .bundle-name {
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .metrics {
        display: flex;
        align-items: center;

        .metric {
            margin-right: $spacing-600;
            display: flex;
            flex-direction: column;
            font-size: px-to-rem(12px);
        }

        .metric-value {
            line-height: px-to-rem(52px);
            font-size: px-to-rem(52px);
        }
    }

    .campaign {
        margin-bottom: $spacing-200;
        display: flex;

        &.header {
            color: $color-gray-800;
            margin-bottom: $spacing-100;
        }

        .date {
            max-width: 140px;
            padding-left: $spacing-200;
            margin-left: auto;
        }
    }

    .placeholder-container {
        display: flex;
        flex-direction: column;
        width: 100%;

        .placeholder {
            margin-bottom: $spacing-100;
        }
    }

    [dir=rtl] {
        .metrics {
            .metric {
                margin: 0 0 0 $spacing-600;
            }
        }

        .campaign {
            .date {
                padding: 0 $spacing-200 0 0;
                margin: 0 auto 0 0;
            }
        }
    }
</style>
